import Header from './Header';
import background from './img/softwarePartners.webp';
import screenshotWordpressUpload from './img/screenshot-wp-uploadpng.png';
import screenshotWpAdd from './img/screenshot-wp-add.png';
import screenshotWpUploadPlugin from './img/screenshot-wp-uploadplugin.png';
import screenshotDeveloperHub from './img/screenshot-developer-hub.webp';
import screenshotCreateNewApp from './img/screenshot-create-new-application.webp';
import screenshotSecrets from './img/screenshot-secrets.webp';
import screenshotWebhooks from './img/screenshot-webhooks.webp';
import screenshotGravityFormsSettings from './img/screenshot-gravity-forms-settings.png';
import MobileNavigation from './MobileNavigation';
import { CopyBlock, dracula } from 'react-code-blocks';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import { Section, openSection } from './DocSection';

const wrap = { textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' };
const linkStyle = { color: '#007bff', textDecoration: 'underline' };

const DeveloperGravityForms = () => {
  return (
    <>
      <MobileNavigation />
      <section className="bg-[#212121] woo-commerce">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Header />
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">iQ Pro+ Gravity Forms Plugin</h3>
          </div>
          <div className="flex p-16 row flex-col justify-center flex-start gap-6 self-stretch rounded-[28px] bg-white !mb-10">
            <h2 className="text-black large">Overview</h2>
            <p className="text-black light" style={wrap}>
              The{' '}
              <Link to="/integrations-gravity-forms-downloads" style={linkStyle}>
                iQPro+ for Gravity Forms add-on
              </Link>{' '}
              connects any Gravity Form to your iQPro+ Gateway so you can take one-time credit card
              and ACH payments from a form submission. The browser tokenizes card details through a
              hosted iframe, and the plugin tokenizes bank details server-side before anything is
              charged, so no card number or account number is stored on your site.
            </p>
            <p className="text-black light" style={wrap}>
              The add-on runs on the official Gravity Forms payment framework: you configure
              payments through feeds, results land on the form entry as <b>Paid</b> or <b>Failed</b>
              , and later status changes (settlements, voids, refunds) arrive by webhook and update
              the entry. This guide covers installation, versioning, app registration in the gateway
              portal, every section of the settings screen, building a form that takes payments, and
              reading the results.
            </p>
            <h2 className="font-normal text-black">On this page</h2>
            <ol className="ml-5 list-decimal gap-x-12 marker:text-gray-500 md:columns-2 [&>li]:break-inside-avoid [&>li]:py-1">
              <li className="text-black light">
                <a onClick={openSection} href="#versioning-and-updates" style={linkStyle}>
                  Versioning and Updates
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#installing-the-plugin" style={linkStyle}>
                  Installing the Plugin
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#app-registration-setup" style={linkStyle}>
                  App Registration Setup
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#settings-page" style={linkStyle}>
                  Settings Page
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#credentials-and-environment" style={linkStyle}>
                  Credentials and Environment
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#accepted-methods" style={linkStyle}>
                  Accepted Methods
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#webhook-setup" style={linkStyle}>
                  Webhook Setup
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#webhook-creation" style={linkStyle}>
                  Webhook Creation
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#secret-renewal" style={linkStyle}>
                  Secret Renewal
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#logging" style={linkStyle}>
                  Logging
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#building-a-payment-form" style={linkStyle}>
                  Building a Payment Form
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#taking-a-payment" style={linkStyle}>
                  Taking a Payment
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#entries-and-payment-status" style={linkStyle}>
                  Entries and Payment Status
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#going-live" style={linkStyle}>
                  Going Live
                </a>
              </li>
              <li className="text-black light">
                <a onClick={openSection} href="#troubleshooting" style={linkStyle}>
                  Troubleshooting
                </a>
              </li>
            </ol>
            <h2 className="font-normal text-black">Prerequisites</h2>
            <p className="text-black light">
              This plugin is currently compatible with the following versions:
            </p>
            <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
              <colgroup>
                <col style={{ width: '33%' }} />
                <col style={{ width: '34%' }} />
                <col style={{ width: '33%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th className="font-bold text-center text-black">Component</th>
                  <th className="font-bold text-center text-black">Compatible Versions</th>
                  <th className="font-bold text-center text-black">Recommended</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <b>PHP</b>
                  </td>
                  <td>8.1.x, 8.2.x, 8.3.x</td>
                  <td>
                    <b>8.3.x</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>WordPress</b>
                  </td>
                  <td>6.0 or newer</td>
                  <td>
                    <b>Latest release</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Gravity Forms</b>
                  </td>
                  <td>2.6 or newer</td>
                  <td>
                    <b>Latest release</b>
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="text-black light">You also need:</p>
            <ul className="ml-5 list-disc">
              <li className="text-black light" style={wrap}>
                A licensed, active Gravity Forms install. Without it the add-on registers nothing
                and shows an admin notice instead.
              </li>
              <li className="text-black light">An iQPro+ Gateway account with portal access.</li>
              <li className="text-black light" style={wrap}>
                A site served over HTTPS with a valid certificate if you want webhooks. See{' '}
                <a onClick={openSection} href="#webhook-setup" style={linkStyle}>
                  Webhook Setup
                </a>{' '}
                for what happens without one.
              </li>
            </ul>
            <div className="my-4 callout">
              <p className="mb-0 text-black light" style={wrap}>
                <strong>IMPORTANT:</strong> Gravity Forms deprecated its own Credit Card field. This
                add-on ships its own field, the Basys Payment field. Do not use the legacy Credit
                Card field with this add-on.
              </p>
            </div>
            <Section id="versioning-and-updates" title="Versioning and Updates" open>
              <p className="text-black light" style={wrap}>
                You’ll find the version you are running on the WordPress <b>Plugins</b> page under{' '}
                <b>iQPro+ for Gravity Forms</b>, and in the plugin header of the <code>.zip</code>{' '}
                file. All released versions are listed on the{' '}
                <Link to="/integrations-gravity-forms-downloads" style={linkStyle}>
                  downloads page
                </Link>
                .
              </p>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>NOTE:</strong> 0.x builds are pre-release. Run them in Sandbox against
                  test cards, not against live customers.
                </p>
              </div>
              <p className="text-black light">To update:</p>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  Download the new <code>.zip</code> from the{' '}
                  <Link to="/integrations-gravity-forms-downloads" style={linkStyle}>
                    downloads page
                  </Link>
                  .
                </li>
                <li className="text-black light">
                  Go to <b>Plugins → Add New → Upload Plugin</b> and upload the new{' '}
                  <code>.zip</code>.
                </li>
                <li className="text-black light" style={wrap}>
                  WordPress detects the existing install and offers to replace it. Choose{' '}
                  <b>Replace current with uploaded</b>.
                </li>
                <li className="text-black light">
                  Confirm the new version number on the <b>Plugins</b> page.
                </li>
              </ol>
              <p className="text-black light" style={wrap}>
                Your settings survive an update. Credentials, environment, accepted methods, webhook
                key, and feeds live in the database rather than the plugin folder, so replacing the
                files does not clear them. Deactivating the plugin also leaves settings intact; it
                only stops the scheduled secret-renewal check.
              </p>
              <p className="text-black light" style={wrap}>
                Deleting the plugin from WordPress does remove everything: stored credentials, the
                webhook public key, processor ids, and the webhook event history. If you delete and
                reinstall, you’ll re-enter credentials and save again.
              </p>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>NOTE:</strong> After any upgrade, clear your site and browser cache before
                  testing. A cached copy of the old payment field script is a likely cause of
                  confusing test results.
                </p>
              </div>
            </Section>
            <Section id="installing-the-plugin" title="Installing the Plugin">
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  In the <b>WordPress Admin Panel</b>, navigate to the <b>Plugins</b> section.
                </li>
                <li className="text-black light">
                  Click either the <b>“Add Plugin”</b> option in the sidebar dropdown
                  <img
                    src={screenshotWordpressUpload}
                    alt="Screenshot of WordPress Add Plugin menu"
                  />
                  <br />
                  or the <b>“Add New”</b> button on the Installed Plugins page.
                  <img src={screenshotWpAdd} alt="Screenshot of WordPress Add Plugin button" />
                </li>
                <li className="text-black light">
                  At the top of the page, click the <b>“Upload Plugin”</b> button.
                  <img
                    src={screenshotWpUploadPlugin}
                    alt="Screenshot of WordPress Upload Plugin page"
                  />
                </li>
                <li className="text-black light">
                  Choose the{' '}
                  <Link to="/integrations-gravity-forms-downloads" style={linkStyle}>
                    plugin <code>.zip</code> file
                  </Link>{' '}
                  and click <b>“Install Now”</b>.
                </li>
                <li className="text-black light">
                  Click <b>“Activate”</b>.
                </li>
                <li className="text-black light">
                  Return to the <b>Plugins</b> page and confirm the plugin is listed and active.
                </li>
              </ol>
              <p className="text-black light" style={wrap}>
                Success condition: <b>Forms → Settings</b> now lists an <b>iQPro+</b> tab.
              </p>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>NOTE:</strong> If you see a notice reading “iQPro+ for Gravity Forms
                  requires Gravity Forms 2.6 or newer,” install or update Gravity Forms first. The
                  add-on stays dormant until it finds a supported version.
                </p>
              </div>
            </Section>
            <Section id="app-registration-setup" title="App Registration Setup">
              <p className="text-black light" style={wrap}>
                Before the plugin can talk to your gateway you need a Client ID and Client Secret
                from an app registration. Create it in the portal for the environment you are
                configuring: the sandbox portal for sandbox credentials, the production portal for
                production credentials. Log in to the iQPro+ portal and navigate to{' '}
                <b>Developer Hub → Applications</b>.
              </p>
              <img src={screenshotDeveloperHub} alt="Screenshot of Developer Hub" />
              <h2 className="font-normal text-black">Creating the Client Credentials</h2>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  On the <b>Applications</b> page, click <b>Create New +</b>.
                </li>
                <li className="text-black light" style={wrap}>
                  Enter an <b>Application Name</b>. For role, select{' '}
                  <b>Integrator Service Account</b>, then click <b>Create</b>.
                  <div className="my-4 callout">
                    <p className="mb-0 text-black light">
                      <strong>IMPORTANT:</strong> The role <span className="underline">MUST</span>{' '}
                      be Integrator Service Account. Any other role fails the connection test and
                      the plugin will not process payments.
                    </p>
                  </div>
                  <img src={screenshotCreateNewApp} alt="Screenshot of Create New Application" />
                </li>
                <li className="text-black light" style={wrap}>
                  Once created, the <b>Client ID</b> appears under the application name as a UUID.
                  Record it.
                </li>
                <li className="text-black light" style={wrap}>
                  Under <b>Details</b>, find <b>Secrets</b> and click <b>+ Add New Secret</b>. Enter
                  a name for the secret and create it.
                  <img src={screenshotSecrets} alt="Screenshot of Secrets" />
                  <div className="my-4 callout">
                    <p className="mb-0 text-black light" style={wrap}>
                      <strong>NOTE:</strong> The portal displays the secret value once, at creation.
                      There is no way to view it again afterward, so record it now. Each application
                      allows a maximum of two secrets, which matters for renewal (see{' '}
                      <a onClick={openSection} href="#secret-renewal" style={linkStyle}>
                        Secret Renewal
                      </a>{' '}
                      below).
                    </p>
                  </div>
                </li>
              </ol>
              <p className="text-black light" style={wrap}>
                You also need your <b>Gateway ID</b>, which identifies the gateway your transactions
                post to. You’ll find it in the portal alongside your gateway configuration. Keep all
                three values (Client ID, Client Secret, Gateway ID) for the next section.
              </p>
            </Section>
            <Section id="settings-page" title="Settings Page">
              <p className="text-black light">All plugin configuration lives on one screen.</p>
              <p className="text-black light">Navigate to:</p>
              <p className="font-semibold text-black">Forms → Settings → iQPro+</p>
              <img
                src={screenshotGravityFormsSettings}
                alt="Screenshot of Gravity Forms iQPro+ settings"
              />
              <p className="text-black light">The screen runs top to bottom in sections:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>iQPro+ Gateway</b> - which environment processes payments
                </li>
                <li className="text-black light" style={wrap}>
                  <b>Sandbox Credentials</b> / <b>Production Credentials</b> - only the selected
                  environment’s section is shown
                </li>
                <li className="text-black light" style={wrap}>
                  <b>Connection Status</b> - what the plugin verified against your gateway on the
                  last save
                </li>
                <li className="text-black light">
                  <b>Payment Methods</b> - card only, or card and ACH
                </li>
                <li className="text-black light">
                  <b>Webhooks</b> - the URL to register in the portal
                </li>
                <li className="text-black light">
                  <b>Secret Renewal</b> - automatic API secret rotation
                </li>
                <li className="text-black light">
                  <b>Logging & Troubleshooting</b> - detailed logging toggle
                </li>
              </ul>
              <p className="text-black light" style={wrap}>
                One <b>Save Settings</b> button saves the whole screen, and changes take effect
                immediately.
              </p>
            </Section>
            <Section id="credentials-and-environment" title="Credentials and Environment">
              <h2 className="font-normal text-black">Selecting an Environment</h2>
              <p className="text-black light">Choose which environment processes payments:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Sandbox (testing)</b> - test cards only, no money moves
                </li>
                <li className="text-black light">
                  <b>Production (live payments)</b> - real charges against real customers
                </li>
              </ul>
              <p className="text-black light" style={wrap}>
                Only one environment is active at a time. Each keeps its own credentials, so
                switching back and forth does not make you re-enter anything. Changing the selection
                and saving switches your live forms over immediately, so make that change on
                purpose. The credential section and status panel update as soon as you change the
                selector; you only ever see the environment you are configuring.
              </p>
              <h2 className="font-normal text-black">Entering API Credentials</h2>
              <p className="text-black light">Enter the three values from your app registration:</p>
              <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
                <colgroup>
                  <col style={{ width: '30%' }} />
                  <col style={{ width: '70%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="font-bold text-center text-black">Field</th>
                    <th className="font-bold text-center text-black">What it is</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <code>Client ID</code>
                    </td>
                    <td style={{ overflowWrap: 'anywhere' }}>
                      The OAuth client id for your app registration. A UUID, in the form{' '}
                      <code>12345678-abcd-1234-abcd-1234567890ab</code>.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <code>Client Secret</code>
                    </td>
                    <td>
                      The secret issued with that registration. Stored encrypted and never displayed
                      again.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <code>Gateway ID</code>
                    </td>
                    <td>
                      The iQPro+ Gateway your transactions post to. Letters, numbers, and hyphens,
                      no spaces.
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>IMPORTANT:</strong> Credentials must match the selected environment.
                  Sandbox credentials will not authenticate against production, and production
                  credentials will not authenticate against sandbox.
                </p>
              </div>
              <p className="text-black light">How the fields behave:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light" style={wrap}>
                  The Client ID and Gateway ID prefill from what is stored. The Client Secret never
                  renders back into the form.
                </li>
                <li className="text-black light" style={wrap}>
                  Once a secret is saved, leaving the Client Secret blank keeps the stored one.
                  Enter a value only when you are replacing it.
                </li>
                <li className="text-black light" style={wrap}>
                  To disconnect an environment, clear both the Client ID and the Gateway ID and
                  save. That removes its credentials and everything derived from them.
                </li>
                <li className="text-black light" style={wrap}>
                  Changing any credential clears the cached token, processor ids, and webhook key
                  for that environment, and the plugin rebuilds them on the same save.
                </li>
              </ul>
              <h2 className="font-normal text-black">Connection Status</h2>
              <p className="text-black light" style={wrap}>
                Saving is also when the plugin tests itself against the gateway. It requests an
                access token, retrieves your processor ids, fetches the webhook public key if it
                does not have one yet, and looks up your app registration. Each result lands in the{' '}
                <b>Connection Status</b> panel for the selected environment.
              </p>
              <p className="text-black light">A healthy panel shows:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light" style={wrap}>
                  <b>Connected to the gateway</b>, with the date and time of the last successful
                  test
                </li>
                <li className="text-black light" style={wrap}>
                  <b>App registration verified</b>, meaning your Client ID matches an app registered
                  on this gateway
                </li>
                <li className="text-black light">
                  <b>Card processor found</b>, with the processor id
                </li>
                <li className="text-black light" style={wrap}>
                  <b>ACH processor found</b>, with the processor id (only shown when ACH is an
                  accepted method)
                </li>
                <li className="text-black light" style={wrap}>
                  <b>Webhook public key stored</b>, meaning the plugin can verify webhook signatures
                </li>
              </ul>
              <p className="text-black light" style={wrap}>
                A failure never blocks the save. You keep your input, the panel names the problem,
                and you can correct it and save again from the same screen. Common results:
              </p>
              <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
                <colgroup>
                  <col style={{ width: '40%' }} />
                  <col style={{ width: '60%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="font-bold text-center text-black">Message</th>
                    <th className="font-bold text-center text-black">What it means</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Could not connect to the gateway with these credentials</td>
                    <td>
                      One of the three values is wrong, or they belong to the other environment. The
                      log records the exact error.
                    </td>
                  </tr>
                  <tr>
                    <td>The app registration has not been verified yet</td>
                    <td>
                      The Client ID does not match an app registration on this gateway, or the
                      registration lookup failed.
                    </td>
                  </tr>
                  <tr>
                    <td>Processor ids could not be retrieved</td>
                    <td>Usually a wrong Gateway ID. Correct it and save again.</td>
                  </tr>
                  <tr>
                    <td>No card processor was found on this gateway</td>
                    <td>Your gateway has no card processor configured. Contact Basys support.</td>
                  </tr>
                  <tr>
                    <td>No ACH processor was found on this gateway</td>
                    <td>
                      ACH is selected as an accepted method but the gateway cannot process it. Bank
                      payments will fail until someone adds a processor.
                    </td>
                  </tr>
                  <tr>
                    <td>The webhook public key has not been retrieved yet</td>
                    <td>The plugin rejects webhooks until it has the key. Save again to retry.</td>
                  </tr>
                </tbody>
              </table>
            </Section>
            <Section id="accepted-methods" title="Accepted Methods">
              <p className="text-black light" style={wrap}>
                In the <b>Payment Methods</b> section, choose what the Basys Payment field offers
                customers:
              </p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Card only</b>
                </li>
                <li className="text-black light">
                  <b>Card and bank account (ACH)</b>
                </li>
              </ul>
              <p className="text-black light" style={wrap}>
                ACH requires an ACH processor on your gateway. Select it, save, and check Connection
                Status; if the ACH processor row is missing or warns, bank payments will fail at
                submission.
              </p>
            </Section>
            <Section id="webhook-setup" title="Webhook Setup">
              <p className="text-black light" style={wrap}>
                iQPro+ sends payment updates to your site as transactions move through their
                lifecycle: settlement, void, refund. Without a webhook, an entry keeps whatever the
                original sale returned and never reflects a later settlement or refund.
              </p>
              <p className="text-black light" style={wrap}>
                The plugin generates your webhook URL and displays it in the <b>Webhooks</b>{' '}
                section, in the form:
              </p>
              <CopyBlock
                text="https://your-site.com/?callback=basysgf"
                theme={dracula}
                customStyle={{ overflowX: 'auto' }}
                language="text"
              />
              <p className="text-black light">Click the field to select it and copy it.</p>
              <img src={screenshotWebhooks} alt="Screenshot of Webhooks" />
            </Section>
            <Section id="webhook-creation" title="Webhook Creation">
              <p className="text-black light">
                To register the webhook with your iQPro+ gateway, complete the following steps:
              </p>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  Log in to your <b>iQPro+ Gateway Portal</b>.
                </li>
                <li className="text-black light">
                  Navigate to: <b>Developer Hub → Webhooks</b>
                </li>
                <li className="text-black light">
                  Click <b>Create New +</b>.
                </li>
                <li className="text-black light">
                  Set the <b>Webhook Type</b> to <b>Transaction</b>.
                </li>
                <li className="text-black light">
                  Paste the <b>Webhook URL</b> from the settings page.
                </li>
                <li className="text-black light">
                  Click <b>Create</b>.
                </li>
              </ol>
              <p className="text-black light" style={wrap}>
                Register the URL in each environment’s portal that you actually use.
              </p>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>NOTE:</strong> Webhooks require a publicly reachable site with a valid,
                  trusted SSL certificate. A local development site will not receive them.
                </p>
              </div>
              <p className="text-black light" style={wrap}>
                The plugin checks every inbound webhook against the public key shown in Connection
                Status, rejects unsigned or forged requests, and ignores a replay of an event it
                already applied. You configure none of that yourself, which is why the webhook
                public key row matters.
              </p>
            </Section>
            <Section id="secret-renewal" title="Secret Renewal">
              <p className="text-black light" style={wrap}>
                iQPro+ API secrets expire roughly once a year. With <b>Automate Secret Renewal</b>{' '}
                enabled, the plugin checks daily and, once the secret is within 90 days of expiry,
                creates a new one, confirms it works, and then removes the old one. No downtime,
                nothing to do by hand.
              </p>
              <p className="text-black light" style={wrap}>
                The panel below the toggle shows the current state: whether renewal is on, when the
                next check runs, and when the current secret expires.
              </p>
              <p className="text-black light" style={wrap}>
                With renewal off, you rotate the secret yourself in the portal before it expires,
                then enter the new secret on this page. The panel warns you once an expiry is within
                90 days and renewal is off.
              </p>
              <p className="text-black light" style={wrap}>
                If an automatic renewal cannot complete, the old secret keeps working and an admin
                notice appears reading <b>“iQPro+ secret renewal needs attention.”</b> Read the
                message, resolve the cause in the portal, and save the settings again.
              </p>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>NOTE:</strong> An app registration holds at most two secrets. If both
                  slots are full, renewal has to clear one before it can create the replacement, so
                  avoid keeping two secrets you care about on the same registration.
                </p>
              </div>
            </Section>
            <Section id="logging" title="Logging">
              <p className="text-black light" style={wrap}>
                The plugin writes logs through the Gravity Forms logging system. To read them:
              </p>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  Go to <b>Forms → Settings → Logging</b>.
                </li>
                <li className="text-black light">
                  Set <b>iQPro+ for Gravity Forms</b> to <b>Log all messages</b>, and save.
                </li>
                <li className="text-black light">
                  Reproduce the problem, then open the log from the same page.
                </li>
              </ol>
              <p className="text-black light" style={wrap}>
                The <b>Detailed logging</b> checkbox on the iQPro+ settings page controls how much
                the plugin records. Leave it off for normal operation, where it logs only failures
                and warnings. Turn it on while investigating a problem and it records every step of
                a payment under a single correlation id, so you can follow one submission end to
                end.
              </p>
              <p className="text-black light" style={wrap}>
                The plugin masks card numbers, tokens, secrets, and bank account and routing numbers
                in every log entry regardless of this setting. It cannot log a full card number.
              </p>
            </Section>
            <Section id="building-a-payment-form" title="Building a Payment Form">
              <p className="text-black light" style={wrap}>
                The settings screen connects your site to the gateway. A form takes payments once it
                has a Basys Payment field and a feed.
              </p>
              <h2 className="font-normal text-black">Adding the Basys Payment Field</h2>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">Open your form in the form editor.</li>
                <li className="text-black light">
                  In the field picker, open the <b>Pricing Fields</b> group.
                </li>
                <li className="text-black light">
                  Click <b>Basys Payment</b> to add it to the form.
                </li>
                <li className="text-black light">Give it a label. It defaults to “Payment.”</li>
              </ol>
              <p className="text-black light" style={wrap}>
                The field renders the hosted card iframe, plus the bank account inputs when ACH is
                enabled. Customers pick a method and enter their details there. Card details go from
                the browser to the tokenizer without touching your server, and the plugin tokenizes
                bank details without storing them on the entry.
              </p>
              <p className="text-black light" style={wrap}>
                The field supports the standard label, description, admin label, error message, and
                CSS class settings. It does not support conditional logic; a form that needs a
                payment needs the field visible.
              </p>
              <p className="text-black light" style={wrap}>
                Your form also needs something that determines the amount: a Product field, a Total
                field, or another pricing field. The feed decides which one it charges.
              </p>
              <h2 className="font-normal text-black">Creating the Payment Feed</h2>
              <p className="text-black light" style={wrap}>
                A feed tells the plugin what to charge and what billing details to send. Feeds live
                per form.
              </p>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  With the form open, go to <b>Settings → iQPro+</b>.
                </li>
                <li className="text-black light">
                  Click <b>Add New</b>.
                </li>
                <li className="text-black light">Fill in the feed using the table below.</li>
                <li className="text-black light">
                  Click <b>Save Settings</b>.
                </li>
              </ol>
              <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
                <colgroup>
                  <col style={{ width: '30%' }} />
                  <col style={{ width: '70%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="font-bold text-center text-black">Setting</th>
                    <th className="font-bold text-center text-black">What to enter</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b>Name</b>
                    </td>
                    <td>A label for your own reference in the feed list.</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Basys Payment Field</b>
                    </td>
                    <td>The field on this form that collects payment details.</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Payment Amount</b>
                    </td>
                    <td>
                      The field that determines the amount, or <b>Form Total</b> to charge the total
                      of all pricing fields.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Billing Information</b>
                    </td>
                    <td>
                      Map your form fields to first name, last name, email, phone, address, address
                      2, city, state, zip, and country.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Conditional Logic</b>
                    </td>
                    <td>
                      Optional. With conditions enabled, only submissions that meet them are
                      charged. With it off, the plugin charges every submission that carries a valid
                      amount.
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>NOTE:</strong> If the feed list tells you to add a Basys Payment field
                  first, the form does not have one yet. Add it in the form editor and come back.
                </p>
              </div>
              <p className="text-black light" style={wrap}>
                Success condition: the feed appears in the form’s iQPro+ feed list and is active.
              </p>
            </Section>
            <Section id="taking-a-payment" title="Taking a Payment">
              <p className="text-black light" style={wrap}>
                When a customer submits the form, the plugin runs a single <b>Sale</b> that
                authorizes and captures in one step, then Gravity Forms records the result on the
                entry.
              </p>
              <p className="text-black light">On approval:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  Gravity Forms creates the entry with a payment status of <b>Paid</b>
                </li>
                <li className="text-black light" style={wrap}>
                  The entry stores the gateway transaction id, amount, and payment method
                </li>
                <li className="text-black light" style={wrap}>
                  The plugin adds a note recording the masked payment method, transaction id, and
                  environment
                </li>
                <li className="text-black light">The customer sees your configured confirmation</li>
              </ul>
              <p className="text-black light">On a decline:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  Gravity Forms still creates the entry, with a payment status of <b>Failed</b>
                </li>
                <li className="text-black light">
                  The note records the decline reason and processor response code
                </li>
                <li className="text-black light" style={wrap}>
                  The plugin replaces your success confirmation with a message telling the customer
                  the payment could not be completed and they have not been charged
                </li>
              </ul>
              <p className="text-black light" style={wrap}>
                Creating the entry on a decline is deliberate. You keep a record of the attempt and
                the reason instead of losing the submission.
              </p>
              <p className="text-black light" style={wrap}>
                Two problems stop a submission before the gateway is called, and the customer stays
                on the form with an error on the payment field: no payment details entered, or the
                same tokenized payment submitted twice (a double-click, or a browser
                back-and-resubmit). The duplicate guard is there so one customer action cannot
                charge a card twice.
              </p>
            </Section>
            <Section id="entries-and-payment-status" title="Entries and Payment Status">
              <p className="text-black light" style={wrap}>
                Open <b>Forms → Entries</b> and select an entry to see the payment result.
              </p>
              <ul className="ml-5 list-disc">
                <li className="text-black light" style={wrap}>
                  <b>Payment Status</b> reads Paid or Failed at submission, and can advance later
                  from a webhook
                </li>
                <li className="text-black light" style={wrap}>
                  <b>Transaction ID</b> is the iQPro+ transaction id, which is what Basys support
                  will ask for
                </li>
                <li className="text-black light" style={wrap}>
                  The entry stores the masked payment method: card brand with first six and last
                  four, or bank account type
                </li>
                <li className="text-black light" style={wrap}>
                  Notes carry the full history, from the original sale result through any later
                  change delivered by webhook
                </li>
              </ul>
              <p className="text-black light">
                Webhook-driven changes you will see after the fact:
              </p>
              <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
                <colgroup>
                  <col style={{ width: '40%' }} />
                  <col style={{ width: '60%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="font-bold text-center text-black">Gateway event</th>
                    <th className="font-bold text-center text-black">Effect on the entry</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Settled</td>
                    <td>Payment completed</td>
                  </tr>
                  <tr>
                    <td>Voided</td>
                    <td>Authorization voided</td>
                  </tr>
                  <tr>
                    <td>Failed or declined</td>
                    <td>Payment failed</td>
                  </tr>
                  <tr>
                    <td>Refunded</td>
                    <td>Payment refunded, with the refunded amount</td>
                  </tr>
                </tbody>
              </table>
              <p className="text-black light" style={wrap}>
                The plugin logs statuses that carry no change, such as pending settlement, and
                leaves the entry alone.
              </p>
            </Section>
            <Section id="going-live" title="Going Live">
              <p className="text-black light">Work through this before switching to production:</p>
              <ol className="ml-5 list-decimal">
                <li className="text-black light" style={wrap}>
                  Complete a full sandbox test: a card payment, an ACH payment if you accept them,
                  and a decline using a test card that declines.
                </li>
                <li className="text-black light">
                  Confirm the Connection Status panel is clean in sandbox.
                </li>
                <li className="text-black light" style={wrap}>
                  Create a production app registration in the production portal and record the
                  Client ID, Client Secret, and Gateway ID.
                </li>
                <li className="text-black light" style={wrap}>
                  Switch the Environment selector to Production, enter the production credentials,
                  and save.
                </li>
                <li className="text-black light">
                  Confirm the production Connection Status panel is clean.
                </li>
                <li className="text-black light">
                  Register the webhook URL in the production portal.
                </li>
                <li className="text-black light" style={wrap}>
                  Run one small live transaction against a real card, verify the entry reads Paid,
                  and refund it from the portal. Confirm the entry updates to refunded.
                </li>
              </ol>
              <div className="my-4 callout">
                <p className="mb-0 text-black light" style={wrap}>
                  <strong>IMPORTANT:</strong> The environment selector governs live forms the moment
                  you save. Do not switch to Production until you have entered and verified the
                  production credentials.
                </p>
              </div>
            </Section>
            <Section id="troubleshooting" title="Troubleshooting">
              <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
                <colgroup>
                  <col style={{ width: '40%' }} />
                  <col style={{ width: '60%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="font-bold text-center text-black">Symptom</th>
                    <th className="font-bold text-center text-black">Where to look</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>The iQPro+ tab is missing from Forms → Settings</td>
                    <td>
                      Gravity Forms is inactive or below 2.6. Check for the admin notice on the
                      Plugins page.
                    </td>
                  </tr>
                  <tr>
                    <td>“Card payments are temporarily unavailable” on the form</td>
                    <td>
                      The plugin could not fetch the tokenization configuration. Check Connection
                      Status and the log.
                    </td>
                  </tr>
                  <tr>
                    <td>“Bank account payments are not enabled”</td>
                    <td>Accepted Payment Methods is set to Card only.</td>
                  </tr>
                  <tr>
                    <td>Bank payments fail at submission</td>
                    <td>
                      No ACH processor on the gateway. Check the ACH row in Connection Status.
                    </td>
                  </tr>
                  <tr>
                    <td>Entries stay Paid and never show a refund or settlement</td>
                    <td>
                      The webhook is not registered, the site is not publicly reachable, or the
                      webhook public key is missing.
                    </td>
                  </tr>
                  <tr>
                    <td>Admin notice: “iQPro+ payments are paused”</td>
                    <td>
                      The site’s WordPress security keys changed and the plugin can no longer
                      decrypt the stored credentials. Re-enter the Client ID, Client Secret, and
                      Gateway ID for each environment you use and save; that restores encryption.
                    </td>
                  </tr>
                  <tr>
                    <td>Admin notice: “iQPro+ secret renewal needs attention”</td>
                    <td>
                      An automatic renewal did not complete. The old secret still works. Read the
                      notice, fix the cause in the portal, and save the settings.
                    </td>
                  </tr>
                </tbody>
              </table>
            </Section>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default DeveloperGravityForms;
